import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { Separator } from "@/components/ui/separator";
import { SettingsMenu } from "@/components/Holizontal/SettingsMenu";

export default function SettingsPage() {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">Settings</h1>
<SettingsMenu />
      <Card className="shadow-card">
        <CardHeader>
          <CardTitle>General Settings</CardTitle>
        </CardHeader>




        <CardContent className="space-y-6">
          <div className="space-y-2">
            <Label>Company Name</Label>
            <Input defaultValue="LoanPro" />
          </div>
          <div className="space-y-2">
            <Label>Default Currency</Label>
            <Input defaultValue="KES" />
          </div>
          <div className="space-y-2">
            <Label>Default Interest Rate (%)</Label>
            <Input type="number" defaultValue="15" />
          </div>
          <Separator />
          <div className="flex items-center justify-between">
            <div>
              <p className="font-medium">Email Notifications</p>
              <p className="text-sm text-muted-foreground">Receive email alerts for loan activities</p>
            </div>
            <Switch defaultChecked />
          </div>
          <div className="flex items-center justify-between">
            <div>
              <p className="font-medium">SMS Notifications</p>
              <p className="text-sm text-muted-foreground">Send SMS reminders to borrowers</p>
            </div>
            <Switch defaultChecked />
          </div>
          <Button className="gradient-primary text-primary-foreground">Save Settings</Button>
        </CardContent>
      </Card>
    </div>
  );
}
